import axios from "axios";
import React, { useState, useEffect, useContext } from "react";

import { AdminExportBatchHistory } from "./AdminExportBatchHistory";

export default function AdminExportBatchQueueMaintenance(props) {
  return <AdminExportBatchHistory passedProps={props.passedProps} />;
}
